import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const loginState = atom({
  key: "VASSLoginNew",
  default: {
    isLogin: false,
    isUserIdStored: false,
    company: "",
    userId: "",
    branchName: "",
    branchCode: "",
    localIP: "",
    saId: "",
    accountId: "",
    camUsable: "",
    nvrUsable: "0",
    isAdmin: false,
    camStatus: "",
  },
  effects_UNSTABLE: [persistAtom],
});